
/* 自定义rule校验 */
export function validateWordFn(rule, value, callback) {
  if (value) {
    var len = 0
    for (var i = 0; i < value.length; i++) {
      var c = value.charCodeAt(i)
      if ((c >= 0x0001 && c <= 0x007c) || (c >= 0xff60 && 0 <= 0xff9f)) {
        /* 单字符 */
        len++
      } else {
        /* 中文2字符 utf-8下占三个字节 */
        len += 3
      }
    }

    if (len <= this) {
      callback()
    } else {
      callback(new Error(`不能超过${this}个字符`))
    }
    
  } 
  callback()
}

/* 表格内校验 */
export function validateWordFnTable(arr, that) {
  let flag = true
  for (var j = 0; j < arr.length; j++) {
    var len = 0
    var item = arr[j]
    console.log(item);
    if (item.word) {
      for (var i = 0; i < item.word.length; i++) {
        var c = item.word.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007c) || (c >= 0xff60 && 0 <= 0xff9f)) {
          /* 单字符 */
          len++
        } else {
          /* 中文2字符 */
          len += 3
        }
      }
    }
    if (len > item.num) {
      flag = false
      that.$message.warning(`不能超过${item.num}个字符`)
      break
    }
  }
  return flag
}
